const e = (e, t) => e + "tab:" + t, t = e => e + "panel", n = e => e + "list", l = (t, n, l, o, r) => {
    const s = ((e, t, n) => {
        let l = e;
        const o = t.length;
        for (;(l = (l + o + n) % o) !== e; ) if (!t[l].disabled) return l;
        return -1;
    })(o, l, r);
    -1 !== s && (t.preventDefault(), document.getElementById(e(n, l[s].value))?.focus());
};

export { e as getTabId, n as getTabListId, t as getTabPanelId, l as stepTo };
//# sourceMappingURL=index.js.map
